// テキスト内訳のパース＆合計ロジック（JS版）

import { parseLine, sanitizePlain, toHalfWidth } from '../utils/numOcr';

export const normalizeNumber = (s) => {
  const sanitized = sanitizePlain(s);
  const normalized = toHalfWidth(sanitized)
    .replace(/[,\s]+/g, '')
    .replace(/^[+]/, '')
    .trim();
  if (!normalized) return null;
  const n = Number(normalized);
  return Number.isFinite(n) ? n : null;
};

// 1行を数値へ解釈
export const parseLineToValue = (lineRaw) => {
  const parsed = parseLine(lineRaw);
  return parsed ? parsed.value : null;
};

export const sumLines = (text) => {
  const sanitized = sanitizePlain(text);
  const lines = sanitized.split(/\r?\n/);
  let sum = 0;
  const details = lines.map((raw, i) => {
    const parsed = parseLine(raw);
    const value = parsed ? parsed.value : null;
    if (value != null) sum += value;
    return { index: i + 1, raw, value };
  });
  return { sum, details };
};
